export default {
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
}
